import { LOADING, FAILED, SUCCESS } from './constants';
import { listRoleUser, userRolePost, userRolePut, listPermissionUser } from '../../utils/api';

export function fetchPermissionUser(search = '') {
  return async (dispatch) => {
    const KEY = 'Permission';
    try {
      dispatch(loadingAction(true, KEY));
      const params = { search, page: 1, size: 100 };
      const { data, meta } = await listPermissionUser(params);
      const dataOptions = data.map((val) => {
        return { value: val.permitionId, label: val.name, path: val.path };
      });
      dispatch(successAction({ dataOptions, meta }, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function fetchRoleUser(scrollId = '', search = '') {
  return async (dispatch, getState) => {
    const state = getState();
    const KEY = 'Role';
    const { page, totalPage } = state.role.dataRole.meta;
    if (scrollId && page > 1 && page >= totalPage) {
      return;
    }
    try {
      dispatch(loadingAction(true, KEY));
      const params = { search, page: 1, size: 100 };
      const { data, meta } = await listRoleUser(params);
      dispatch(successAction({ data, meta }, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function createRoleUser(payload) {
  return async (dispatch) => {
    const key = 'SubmitRole';
    dispatch(loadingAction(true, key));
    try {
      await userRolePost(payload);
      dispatch(successAction(false, 'SubmitUpdateRole'));
      dispatch(successAction(true, key, payload.name));
    } catch (error) {
      dispatch(successAction(false, 'SubmitUpdateRole'));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function editRoleUser(payload) {
  return async (dispatch) => {
    const key = 'SubmitUpdateRole';
    dispatch(loadingAction(true, key));
    try {
      await userRolePut(payload);
      dispatch(successAction(false, 'SubmitRole'));
      dispatch(successAction(true, key, payload.name));
    } catch (error) {
      dispatch(successAction(false, 'SubmitRole'));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}
